<template>
    <div>
    <b-modal v-model="showPopup" id="message-modal" hide-footer :close-on-backdrop="false" class="pt-8" centered
    header-class="p-0" footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
    <template #modal-title>
        <div class="title-block text-center p-2">
            {{ $translate('description_for')}} {{ activitydata.reference_no }}
        </div>
    </template>
   
    <div class="my-3">
        <!-- <label class="mb-3" for="input-activity-message"><strong>{{ $translate('') }}</strong></label> -->
        {{ popup_description }}
    </div>
    <!-- <div class="d-flex justify-content-center">
        <b-button id="message-save-btn" v-show="!model.id || (model.user_id == user.id)" size="sm" @click="createMessage" class="btn-fw me-3" v-if="hasPermissionCreate"
            :disabled="(submitting ? true : false) || (viewMode && !isNew)" variant="info">{{ model.hash
                ? $translate('update_message') : $translate('add_message') }}</b-button>
        <b-button id="message-close-btn" size="sm" @click="isModalVisible = false" variant="info" class="btn-fw">{{ $translate('close')
        }}</b-button>
    </div> -->
</b-modal>
    <div v-if="description !== null">
      <p class="m-0 opp-description">
        <span v-if="!showPopup">{{ truncatedDescription }}</span>
        <span v-else>{{ truncatedDescription }}</span>
        <span 
          v-if="description.length > 120 && !showPopup" 
          @click.stop="togglePopup"
          class="expand"
        >
          ... Show more
        </span>
      </p>
      
    
    </div>
</div>
  </template>
  
  <script>
  export default {
    props: [
      'description',
      'activitydata'
  ],
    data() {
      return {
        showPopup: false,
        popupPosition: { top: 0, left: 0 },
        popup_description : this.description,
      };
    },
    computed: {
      truncatedDescription() {
        return this.description && this.description.length > 120
          ? this.description.slice(0, 120) + '...'
          : this.description;
      }
    },
    methods: {
      togglePopup() {
        this.showPopup = !this.showPopup;
        if (this.showPopup) {
          this.calculatePopupPosition();
          // Add event listener to close popup on click outside
          document.addEventListener('click', this.closePopupOnClickOutside);
        } else {
          // Remove event listener when popup is closed
          document.removeEventListener('click', this.closePopupOnClickOutside);
        }
      },
      closePopup() {
        this.showPopup = false;
        document.removeEventListener('click', this.closePopupOnClickOutside);
      },
      closePopupOnClickOutside(event) {
        if (!this.$refs.popupContainer.contains(event.target)) {
          this.closePopup();
        }
      },
      calculatePopupPosition() {
        this.$nextTick(() => {
          const descriptionElem = this.$el.querySelector('.opp-description');
          if (descriptionElem) {
            const descriptionRect = descriptionElem.getBoundingClientRect();
            this.popupPosition.top = descriptionRect.bottom + window.scrollY + 'px';
            this.popupPosition.left = descriptionRect.left + 'px';
          }
        });
      }
    },
    destroyed() {
      // Ensure event listener is removed when component is destroyed
      document.removeEventListener('click', this.closePopupOnClickOutside);
    }
  };
  </script>
  
  <style scoped>
  .expand {
    cursor: pointer;
    color: blue;
    text-decoration: underline;
  }
  
  .popup-container {
    position: absolute;
    z-index: 9999; /* Ensure popup is above other content */
    background: white;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  }
  
  .popup-content {
    padding: 10px;
  }
  
  .popup-scroll-content {
    max-height: 200px; /* Limit max height for scrollable content */
    overflow-y: auto;
  }
  
  .close {
    position: absolute;
    top: 5px;
    right: 10px;
    cursor: pointer;
    font-size: 16px;
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  </style>
  